import { Button as PrButton, ButtonProps } from 'primereact/button';

const btnSizeClass = {
  sm: 'text-xs px-2 py-1 rounded-md',
  md: 'text-sm px-3 py-1.5 rounded-lg',
  lg: 'text-base font-medium px-3 py-1.5 rounded-lg',
  xl: 'text-lg font-medium px-3 py-1.5 rounded-lg',
};

const btnColorClass = {
  primary:
    'bg-pv-primary-primary-500 hover:bg-pv-primary-primary-800 active:bg-pv-primary-primary-300 border border-pv-primary-primary-500 hover:border-pv-primary-primary-800 active:border-pv-primary-primary-100 text-white',
  secondary:
    'bg-white hover:bg-pv-primary-primary-100 border border-pv-primary-primary-500 text-pv-primary-primary-500 active:bg-pv-primary-primary-50 active:border-pv-primary-primary-100 active:text-pv-primary-primary-300',
  ghost:
    'bg-white hover:bg-pv-neutral-grey-50 text-pv-neutral-grey-600 hover:text-pv-neutral-grey-800 active:bg-white active:text-pv-neutral-grey-300 border border-transparent hover:border-pv-neutral-grey-50 active:border-transparent',
  'blue ghost':
    'bg-white hover:bg-pv-primary-primary-50 border-none text-pv-primary-primary-500 hover:text-pv-primary-primary-800 active:bg-white active:text-pv-primary-primary-300',
};

const btnDisabledColorClass = {
  primary:
    'bg-pv-neutral-grey-100 text-pv-neutral-grey-300 border border-pv-neutral-grey-100',
  secondary:
    'bg-pv-neutral-grey-100 text-pv-neutral-grey-300 border border-pv-neutral-grey-100',
  ghost: 'bg-white text-pv-neutral-grey-300 border border-white',
  'blue ghost': 'bg-white text-pv-primary-primary-300 border border-white',
};

interface Props extends ButtonProps {
  btnSize: 'sm' | 'md' | 'lg' | 'xl';
  btnColor: 'primary' | 'secondary' | 'ghost' | 'blue ghost';
}

export const Button = ({
  label = '',
  onClick,
  btnSize = 'md',
  type = 'button',
  children,
  btnColor = 'primary',
  disabled,
  className = '',
}: Props) => {
  return (
    <div
      className={`${className} ${
        disabled ? `cursor-not-allowed` : `cursor-pointer`
      }`}
    >
      <PrButton
        onClick={(e) => {
          onClick?.(e);
        }}
        label={label}
        className={`h-min gap-2 w-full`}
        disabled={disabled}
        type={type}
        pt={{
          root: () => {
            return {
              className: `flex items-center justify-center ${
                btnSizeClass[btnSize as keyof typeof btnSizeClass]
              } ${
                disabled
                  ? btnDisabledColorClass[
                      btnColor as keyof typeof btnDisabledColorClass
                    ]
                  : btnColorClass[btnColor as keyof typeof btnColorClass]
              }`,
              style: {
                boxShadow: 'none',
              },
            };
          },
        }}
      >
        {children}
      </PrButton>
    </div>
  );
};
